require("intersection-observer");

web = window.web = window.web || {};

var $ = require("jquery");
//export to window
window.$ = $;
window.jQuery = $;
require("bootstrap/collapse");
require("bootstrap/carousel");
require("bootstrap/tab");
require("bootstrap/modal");
require("./third/jsClock");
require("@fancyapps/fancybox/dist/jquery.fancybox");
//require('jquery.event.move/js/jquery.event.move');
//require('jquery.event.swipe/js/jquery.event.swipe');
//require('scrollify/jquery.scrollify.min');
//require('third/owl.carousel.min');
//require('third/retina');
require("video.js/dist/video-js/video");
window.Swiper = require("swiper/dist/js/swiper");
window.QRious = require("./third/qrious.min");
window.QRCodeStyling = require("./third/qr-code-styling");

import lozad from "lozad";

var MapRenderer = require("./map/renderer");
var NextPageLoader = require("./web/autoNextPageLoader");
var ScrollControl = require("./web/ScrollControl");

web.Director = require("./web/Director");
web.ParamResolver = require("./web/ParamResolver");
web.SlideLinks = require("./web/SlideLinks");
web.AnchorSlider = require("./web/AnchorSlider");
web.UrlStateCommiter = require("./web/UrlStateCommiter");
web.IScroll = require("iscroll/build/iscroll");
web.Device = require("./web/Device");
web.Preloader = require("./web/Preloader");
web.SocialShare = require("./web/SocialShare");
web.ContentLoader = require("./web/ContentLoader");

web.CreditsDirector = require("./credits/Director");

web.UnderwaterDirector = require("./underwater/Director");

require("./third/slick.min");

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

lozad(".lozad", {
  loaded: function (el) {
    console.log(el);
  },
});

$.extend($.expr[":"], {
  containsi: function (elem, i, match, array) {
    return (
      (elem.textContent || elem.innerText || "")
        .toLowerCase()
        .indexOf((match[3] || "").toLowerCase()) >= 0
    );
  },
});

function getViewport() {
  var e = window,
    a = "inner";
  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  return { width: e[a + "Width"], height: e[a + "Height"] };
}

/* Screen resolution */
var ratio = window.devicePixelRatio || 1;
var w = screen.width * ratio;
var h = screen.height * ratio;

var mySwiper = new Swiper(".swiper-container", {
  // Optional parameters
  loop: true,
  pagination: ".swiper-pagination",
  paginationClickable: true,
  autoplay: 7000,
  autoplayDisableOnInteraction: false,
  // hashnav: true,
  nextButton: '.swiper-button-next',
  prevButton: '.swiper-button-prev'
});

/* Height of the carousel */
var swiperHeight =
  document.documentElement.clientHeight - $(".header-fixed").height();

$(".js_setHeightAsClientHeightWithoutHeader").height(swiperHeight);

/* Dynamically loads more News */
var nextPageLoader = new NextPageLoader(
  "[data-ride=next-page-loader]",
  "[data-load=next]"
);
nextPageLoader.init();

$(document).on("afterContentsReplaced", function () {
  var nextPageLoader = new NextPageLoader(
    "[data-ride=next-page-loader]",
    "[data-load=next]"
  );
  nextPageLoader.init();

  observer.observe();
});

/**
 * Hide/Show bootstrap carousel controls depending on active item
 */
var bsCarouselUpdate = function () {
  var carousels = $(".film-carousel");
  $.each(carousels, function (i) {
    var carousel = $(carousels[i]);
    var firstItem = carousel.find(".carousel-inner .item:first");
    var lastItem = carousel.find(".carousel-inner .item:last");
    var nextControl = carousel.children(".right");
    var prevControl = carousel.children(".left");
    if (firstItem.hasClass("active")) {
      prevControl.hide();
      nextControl.show();
    } else if (lastItem.hasClass("active")) {
      nextControl.hide();
      prevControl.show();
    } else {
      nextControl.show();
      prevControl.show();
    }
  });
};
bsCarouselUpdate();
$(".carousel").on("slid.bs.carousel", bsCarouselUpdate);

$(window).resize(function () {
  $("[data-ride=carousel]").carousel();
});

/**
 *
 */
$.each($('.nav-tabs a[data-toggle="tab"]'), function () {
  if (location.hash.match($(this).attr("href"))) {
    $(this).tab("show");
    if (location.hash.match("#")) {
      location.href = location.hash;
    }
  }
});

/**
 * Google map
 */

$.each($(".map"), function () {
  var gmap = new MapRenderer();
  gmap.decorate($(this));
  var center = gmap.map.getCenter();
  $(document).on("shown.bs.tab", function (e) {
    google.maps.event.trigger(gmap.map, "resize");
    gmap.map.setCenter(center);
  });
});

/**
 *  Pdf fancy view
 */
(function () {
  $("body").on(
    "click",
    ".js_fancyBox-openContentFromWindowContext",
    function (e) {
      var $t = $(this);
      e.preventDefault();

      var html = $t.data("htmlId");
      var video = $t.data("videoId");

      $.fancybox.open({
        src: html,
        caption: $t.attr("title"),
        type: "inline",
        opts: {
          afterShow: function (instance, current) {
            if (video !== undefined) {
              console.log(video);
              videojs("#" + video);
            }
          },
          beforeClose: function () {
            if (video !== undefined) {
              console.log(video);
              videojs("#" + video).dispose();
            }
          },
        },
      });
    }
  );
})();

/**
 *  Print button
 */
(function () {
  $("body").on("click", ".js_printButton", function (e) {
    e.preventDefault();
    try {
      window.print();
    } catch (e) {}
  });
})();

/**
 *  Back button
 */
(function () {
  $("body").on("click", ".js_backButton", function (e) {
    var $t = $(this);
    e.preventDefault();
    try {
      if (history.length > 1) {
        window.history.back();
      } else {
        window.location.href = $t.attr("href");
      }
    } catch (e) {
      window.location.href = $t.attr("href");
    }
  });
})();

/**
 * CallculateHeight module
 */

(function () {
  $(".js_callculateHeight-wrapper").each(function () {
    var $this = $(this);
    var max = 0;
    $this.find(".js_callculateHeight-item").each(function () {
      var $this2 = $(this);
      if (max < $this2.outerHeight()) {
        max = $this2.outerHeight();
      }
    });

    if (!!max) {
      $this.css({
        "min-height": max,
      });
    }
  });
})();

var menuTimout;

/**
 * TOP button
 */

(function () {
  var CURRENT_SCROLL = 0;
  var btnTop = $("#js_footerTopBtn");
  _checkBtnTop();

  setInterval(function () {
    window.pageYOffset != CURRENT_SCROLL && _checkBtnTop();
  }, 10);

  function _checkBtnTop() {
    CURRENT_SCROLL = window.pageYOffset;
    if (CURRENT_SCROLL > 200) {
      btnTop.fadeIn();
    } else {
      btnTop.fadeOut();
    }
  }

  btnTop.click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });
})();

/**
 * Products menu feature
 */
$(".show-submenu-on-hover").on("mouseenter", function () {
  if (getViewport().width > 767) {
    var $t = $(this);
    $t.addClass("active");
    // clearTimeout(menuTimout)
  }
});

$(".show-submenu-on-hover").on("mouseleave", function () {
  if (getViewport().width > 767) {
    var $t = $(this);
    menuTimout = setTimeout(function () {
      $t.removeClass("active");
    }, 10);
  }
});

$(".show-submenu-on-click > a").on("click", function (e) {
  if (getViewport().width < 768) {
    var $t = $(this).parent();
    $t.toggleClass("active");
    e.preventDefault();
  }
});

$(".submenu-fade").on("mouseenter", function () {
  $(".show-submenu-on-hover").removeClass("active");
});

/**
 * Fulltext form
 */
$(".js_toggleSearch").on("click", function (e) {
  if (!$(".navbar-form").hasClass("active")) {
    $(".navbar-form").addClass("active");
    $(".navbar-form").css("z-index", 1).animate({ opacity: 1 }, 150);
    $(".navbar-fulltext--container")
      .css("z-index", 100)
      .animate({ opacity: 1 }, 150);
    $("#query").focus();
  } else {
    $(".navbar-form").removeClass("active");
    $(".navbar-form").css("z-index", -1).animate({ opacity: 0 }, 150);
    $(".navbar-fulltext--container")
      .css("z-index", 0)
      .animate({ opacity: 1 }, 150);
  }
});

/**
 * Hamburger toggle
 */
$(".navbar-toggle").on("click", function (e) {
  $(".navbar-toggle").toggleClass("active");
  $(".navbar-main").css({ width: "100%" });
  e.preventDefault();
});

/**
 * Submenu toggle
 */
$(".submenu-item-trigger").on("click", function () {
  if ($(this).hasClass("submenu-item-trigger--opened")) {
    $(this).parent().parent().find(".submenu-dropdown").stop().slideUp(200);
    $(this).removeClass("submenu-item-trigger--opened");
    $(this).parent().removeClass("submenu-root");
  } else {
    $(this).parent().parent().find(".submenu-dropdown").stop().slideDown(200);
    $(this).addClass("submenu-item-trigger--opened");
    $(this).parent().addClass("submenu-root");
  }
});

/**
 * ScrollControl
 */
var scrollControl = new ScrollControl();
scrollControl.init();
function _processScrollControlEvent() {
  var scrollTop = scrollControl.getScrollTop();
  var $header = $(".js_scrollControl-header");

  if (scrollTop > 100) {
    $(".icon-top.go-top").stop().fadeIn(500);
  } else {
    $(".icon-top.go-top").stop().fadeOut(500);
  }

  //Underwater sipka
  if (scrollTop > 50) {
    $(".js_scrollToProducts").stop().fadeOut(500);
  } else {
    $(".js_scrollToProducts").stop().fadeIn(500);
  }

  //    if (getViewport().width >= 768) {
  //        if (scrollTop > 90) {
  //
  //            $header.addClass("smaller-header");
  //        } else {
  //            $header.removeClass("smaller-header");
  //        }
  //    } else {
  //        $header.removeClass("smaller-header");
  //    }
}
$(scrollControl).on("onScroll", function (e) {
  _processScrollControlEvent();
});
$(scrollControl).on("onInit", function (e) {
  _processScrollControlEvent();
});

/* Responsive videos */
var $allVideos = $(
  "iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com'], iframe[src*='//www.imdb.com']"
);
$allVideos.each(function () {
  $(this).wrap('<div class="video-wrapper"></div>');
});

/* Toggle accordeon */
function toggleIcon(e) {
  $(e.target)
    .prev(".accordion__card-header")
    .find(".accordion__card-header-icon")
    .toggleClass(
      "accordion__card-header-icon--plus accordion__card-header-icon--minus"
    );
  $(e.target)
    .parent()
    .find(".accordion__card")
    .prevObject[0].classList.toggle("accordion__card--nonactive");
  $(e.target)
    .parent()
    .find(".accordion__card")
    .prevObject[0].classList.toggle("accordion__card-is-open");
  $(e.target)
    .find(".job-contact-bar__button")
    .toggleClass("job-contact-bar__button-is-inview");
}
$(".accordion").on("hidden.bs.collapse", toggleIcon);
$(".accordion").on("shown.bs.collapse", toggleIcon);

var hash = window.location.hash;
var anchor = $('a[href$="' + hash + '"]');
if (anchor.length > 0) {
  anchor.click();
}

$(".panel-collapse").on("show.bs.collapse", function (e) {
  var $panel = $(this).closest(".panel");
  var $open = $(this).closest(".panel-group").find(".panel-collapse.in");

  var additionalOffset = 0;
  if ($panel.prevAll().filter($open.closest(".panel")).length !== 0) {
    additionalOffset = $open.height();
  }
  $("html,body").animate(
    {
      scrollTop: $panel.offset().top - additionalOffset - 170,
    },
    500
  );
});

var hyphensBlockNo = document.querySelectorAll("span.no-hyphens");
var hyphensBlockAgain = document.querySelectorAll("span.again-hyphens");

for (var i = 0; i < hyphensBlockNo.length; i++) {
  var hyphenBlockHasClassNo = $(".no-hyphens");
  hyphenBlockHasClassNo.removeClass("no-hyphens");
}
for (var j = 0; j < hyphensBlockAgain.length; j++) {
  var hyphenBlockHasClassAgain = $(".again-hyphens");
  hyphenBlockHasClassAgain.removeClass("again-hyphens");
}

/**
 * checking viewport
 */
$.fn.isInViewport = function () {
  var nav = $(this);

  headerHeight = 0;
  stickyHeight = 0;
  if (getViewport().width > 1200) {
    var headerHeight = 153;
    var stickyHeight = 255;
  } else if (getViewport().width > 992) {
    var headerHeight = 153;
    var stickyHeight = 255;
  } else if (getViewport().width > 767) {
    var headerHeight = 167;
    var stickyHeight = 255;
  } else {
    var stickyHeight = 100;
  }

  if (nav.length) {
    var elementTop = nav.offset().top;
    var elementBottom = elementTop + nav.outerHeight();

    var viewportTop = $(window).scrollTop() + headerHeight;
    var viewportBottom = viewportTop + $(window).height() - stickyHeight;

    return elementBottom >= viewportTop && elementTop <= viewportBottom;
  }
};

$(document).ready(function () {
  // $("#jobForm_1").on("submit", function(){
  //     $("#loader").css('display','block');
  // return true
  // });

  $("#dynamicAreaContactForm_3").on("submit", function () {
    window.frameElement.parentElement.classList.add("ch-100");
  });

  $("#dynamicAreaDownloadForm_2").on("submit", function () {
    window.frameElement.parentElement.classList.add("dh-100");
  });

  $("#dynamicAreaJobForm_1").on("submit", function () {
    window.frameElement.parentElement.classList.add("jh-100");
    window.frameElement.parentElement.classList.add("h-default");
  });

  $("a.js_rentalsLink").on("click touchend", function (event) {
    var headerHeight = 0;
    if (getViewport().width > 767) {
      var headerHeight = 170;
    } else {
      var headerHeight = 8;
    }

    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - headerHeight,
      },
      500
    );
  });

  $(".js_openJobs").on("click", function (e) {
    var areaJobs = $(this).context.id.replace("button", "collapse");
    var sticky = areaJobs.replace("collapse", "stickyBar");
    var areaJobsCount = $(".accordion__card--nonactive").size();

    $(window).on("resize scroll", function () {
      if (areaJobsCount === 1) {
        if (
          $(".accordion__card-is-open")
            .find(".job-contact-bar__button-is-inview")
            .isInViewport()
        ) {
          $("#" + sticky).css("opacity", "0");
          $(".job-contact-bar__button--simple").css("visibility", "visible");
        } else {
          $("#" + sticky).css("opacity", "1");
          $(".job-contact-bar__button--simple").css("visibility", "hidden");
        }
      }

      $(".accordion__card--nonactive").each(function () {
        if ($(this).isInViewport() && !$("#" + areaJobs).isInViewport()) {
          $(".job-contact-bar__button--simple").css("visibility", "hidden");
          $("#" + sticky).animate({ opacity: 1 }, 1);
          // console.log("VIDIM ostatni a nevidím obsah");
        }
        if ($(this).isInViewport() && $("#" + areaJobs).isInViewport()) {
          // Vidim ostatni a vidim i obsah
          $("#" + sticky).css("opacity", "0");
          $(".job-contact-bar__button--simple").css("visibility", "visible");
          // console.log("VIDIM ostatni a vidím obsah");
          if (
            $(".accordion__card-is-open")
              .find(".job-contact-bar__button-is-inview")
              .isInViewport()
          ) {
            // console.log("vidim tlacitko i s ostatnima");
            $("#" + sticky).css("opacity", "0");
            $(".job-contact-bar__button--simple").css("visibility", "visible");
          } else {
            // console.log('Už tlačítko nevidím');
            $("#" + sticky).css("opacity", "1");
            $(".job-contact-bar__button--simple").css("visibility", "hidden");
          }
        }
        if (!$(this).isInViewport() && $("#" + areaJobs).isInViewport()) {
          $(".job-contact-bar__button--simple").css("visibility", "hidden");
          $("#" + sticky).css("opacity", "1");
          // console.log("NEVIDIM ostatni a vidím obsah");
          if (
            $(".accordion__card-is-open")
              .find(".job-contact-bar__button-is-inview")
              .isInViewport()
          ) {
            // console.log("vidim tlacitko");
            $("#" + sticky).css("opacity", "0");
            $(".job-contact-bar__button--simple").css("visibility", "visible");
          } else {
            // console.log('Už tlačítko nevidím');
            $("#" + sticky).css("opacity", "1");
            $(".job-contact-bar__button--simple").css("visibility", "hidden");
          }
        }
        if (!$(this).isInViewport() && !$("#" + areaJobs).isInViewport()) {
          $(".job-contact-bar__button--simple").css("visibility", "hidden");
          $("#" + sticky).css("opacity", "1");
          // console.log("Nevidim nic");
        }
      });
    });

    e.preventDefault();
  });

  var fileclose = $(".fileinput--close");
  var fileinputs = $(".fileinput--input").parents("form").find("input:file");

  fileinputs.on("change", function () {
    var t = $(this);
    var id = t.attr("id");
    var index = t.index();

    if (index < fileinputs.length - 1) {
      t.parents("#" + id + "__container")
        .next()
        .removeClass("hidden");
    }
  });

  fileclose.click(function () {
    var input = $(this);
    var nextFile = $(".force-filled")
      .closest("div")
      .next()
      .find(".force-filled");

    input.parents(".input-group").find(":text").addClass("hidden");
    input.parents(".input-group").find(":text")[0].value = "";
    input.parents(".input-group").find("input:file")[0].value = "";
    input.parents(".input-group").find("span").addClass("hidden");

    for (var i = 0; i < nextFile.prevObject.length; i++) {
      if (
        $(this)
          .parents(".input-group")
          .parents()
          .closest(".force-filled")
          .next()[0].children[0].children[0].children[0].value === ""
      ) {
        $(this)
          .parents(".input-group")
          .parents()
          .closest(".force-filled")
          .next()
          .addClass("hidden");
      }
      // if (($(this).parents('.input-group').parents().closest('.force-filled'))[0].children[0].children[0].children[0].value === '') {
      //     ($(this).parents('.input-group').parents().closest('.force-filled'))[0].classList.add('PPP');
      // }

      if (nextFile.prevObject[i].nextElementSibling !== null) {
        if (
          nextFile.prevObject[i].nextElementSibling.classList.contains(
            "force-filled hidden"
          )
        ) {
          // nextFile.prevObject[i].nextElementSibling.closest('.force-filled').classList.add('AAA');
        } else {
          $(this)
            .parents(".input-group")
            .find("span.btn-fileupload")
            .removeClass("hidden");
        }
      }
    }
  });
});

/**
 *  Show cookie privacy for
 */
(function () {
  $("body").on("click", ".js_showCookiePrivacy", function (e) {
    e.preventDefault();
    klaro.show();
  });
})();

/**
 *  Popup
 */
(function () {
  $("#hpPopup").modal("show");
})();

$('.js_product-slider').slick({
  dots: true,
  prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">' +
              '<svg viewBox="326.6 -213.2 252.1 477.2" width="16" height="32" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M330.4,34.9L555.5,260c5.3,5.3,13.8,5.3,19.1,0c5.3-5.3,5.3-13.8,0-19.1L359.1,25.4l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1 c-2.6-2.6-6.1-4-9.5-4c-3.4,0-6.9,1.3-9.5,4L330.5,15.9C325.2,21.1,325.2,29.7,330.4,34.9z" />\n' +
              '</svg>\n' +
             '</button>',
  nextArrow: '<button class="slick-next" aria-label="Next" type="button">' +
               '<svg viewBox="326.6 -213.2 252.1 477.2" width="16" height="32" xmlns="http://www.w3.org/2000/svg">\n' +
               '\t<path d="M574.7,15.9L349.6-209.2c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1L546,25.4L330.5,240.9 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4L574.6,34.9C579.9,29.7,579.9,21.1,574.7,15.9z" />\n' +
               '</svg>\n' +
             '</button>'
});

function productLogoYPosition() {
  const elementImage = document.querySelector('.product-slider--image');
  const widthImage = elementImage.offsetWidth;

  const elementSlick = document.querySelector('.slick-list');
  const widthSlick = elementSlick.offsetWidth;

  const elementLogo = document.querySelector('.product-content-grid__logo');
  const widthLogo = elementLogo.offsetWidth;

  const elementSlider = document.querySelector('.product-slider');
  const styleSlider = window.getComputedStyle(elementSlider);
  const paddingInlineEndSlider = parseFloat(styleSlider.paddingInlineEnd);

  const logoYPosition = (widthSlick - widthImage) / 2 + paddingInlineEndSlider - (widthLogo / 2);

  elementLogo.style.cssText += 'inset-inline-end: '+logoYPosition+'px; visibility: visible;';
}

if (document.querySelector('.js_product-content-grid__logo')) {
  productLogoYPosition();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      productLogoYPosition();
    }, 200);
  });

}

document.querySelectorAll(".js_productContentGridPerex").forEach((paragraph) => {
  const toggleButton = paragraph.parentElement.querySelector(".js_productToggleButtonReadMore");
  if (!toggleButton) return;

  const lineHeight = parseFloat(getComputedStyle(paragraph).lineHeight);
  const paragraphHeight = paragraph.offsetHeight;
  const maxHeight = lineHeight * 10; // Výška 10 řádků
  const collapsedClass = "product-content-grid__perex--collapsed";

  // Zkontrolujte, zda má text více než 9 řádků
  if (paragraphHeight > maxHeight) {
    toggleButton.classList.remove("hidden"); // Zobrazit tlačítko
    paragraph.classList.add(collapsedClass);

    toggleButton.addEventListener("click", () => {
      const isCollapsed = paragraph.classList.contains(collapsedClass);
      toggleButton.textContent = isCollapsed ? "less …" : "more …";
      paragraph.classList.toggle(collapsedClass);
    });
  }
});

/*
function productGalleryHeight() {
  const elementImage = document.querySelector('.product-slider--image');
  const heightImage = elementImage.offsetHeight;
  const elementSlider = document.querySelector('.product-slider');
  const styleSlider = window.getComputedStyle(elementSlider);
  const marginBlockStartSlider = parseFloat(styleSlider.marginBlockStart);
  const marginBlockEndSlider = parseFloat(styleSlider.marginBlockEnd);
  const heightGallery =  heightImage + marginBlockStartSlider + marginBlockEndSlider;
  const elementProduct = document.querySelector('.product-content-grid')

  elementProduct.style.minBlockSize = heightGallery + 'px';
}

if (document.querySelector('.product-content-grid__item--gallery')) {
  productGalleryHeight();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      productGalleryHeight();
    }, 200);
  });
}
*/

document.querySelectorAll('.toggle-units').forEach(unitBlock => {
  const metricBtn = unitBlock.querySelector('.js_toggleUnitsButtonMetric');
  const imperialBtn = unitBlock.querySelector('.js_toggleUnitsButtonImperial');
  const toggleButtons = unitBlock.querySelectorAll('.toggle-units__button');

  // Najdeme nejbližší větší blok (rodič, který obaluje toggle i tabulku)
  const container = unitBlock.closest('.editor-content');

  if (!metricBtn || !imperialBtn || !container) return;

  function showMetric() {
    const metricElements = container.querySelectorAll('.metric');
    const imperialElements = container.querySelectorAll('.imperial');

    metricElements.forEach(el => el.classList.remove('hide'));
    imperialElements.forEach(el => el.classList.add('hide'));

    toggleButtons.forEach(btn => btn.classList.remove('toggle-units__button--active'));
    metricBtn.classList.add('toggle-units__button--active');
  }

  function showImperial() {
    const metricElements = container.querySelectorAll('.metric');
    const imperialElements = container.querySelectorAll('.imperial');

    imperialElements.forEach(el => el.classList.remove('hide'));
    metricElements.forEach(el => el.classList.add('hide'));

    toggleButtons.forEach(btn => btn.classList.remove('toggle-units__button--active'));
    imperialBtn.classList.add('toggle-units__button--active');
  }

  metricBtn.addEventListener('click', showMetric);
  imperialBtn.addEventListener('click', showImperial);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js_tableContainer").forEach(tableContainer => {
    const productTable = tableContainer.querySelector("table");

    if (productTable) {
      const tableWidth = productTable.offsetWidth;
      if (tableWidth < 940) {
        tableContainer.classList.add("container-970");
      }
    }
  });
});
/**
 * RCH director class
 * manages all javascript components
 */
window.director = new web.Director();
window.director.init();

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function (index, f) {
  $(f);
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js